/* Pertegaz — collection card interactions: bookmark, colour swatches, image slider.
   All click handlers are delegated so they cover cards added by pagination / AJAX filtering. */
(function () {
  /* This file loads on collection pages AND from the cart drawer snippet (so the cart's
     suggested-products cards work on every page). Guard against running twice. */
  if (window.__pzCollectionInit) return;
  window.__pzCollectionInit = true;
  /* Bookmark save state + wishlist drawer live in pz-wishlist.js (loaded globally). */

  /* ================= Card image slider ================= */
  function slides(track) { return track.querySelectorAll('.pz-cardslider__slide'); }

  /* Mobile progress line: thumb width = one viewport's share, position = scroll progress
     (identical maths to the mobile PDP line). */
  function updateHbar(slider) {
    var track = slider.querySelector('[data-pz-cardslider-track]');
    var hbar = slider.querySelector('[data-pz-cardslider-hbar]');
    if (!track || !hbar) return;
    var thumb = hbar.querySelector('.pz-cardslider__hbar-thumb');
    if (!thumb) return;
    var sw = track.scrollWidth, cw = track.clientWidth, range = sw - cw, tw = hbar.clientWidth;
    if (range <= 4 || tw <= 0) { thumb.style.width = '0px'; return; }
    var thumbW = Math.max(24, Math.min(tw, tw * (cw / sw)));
    var prog = Math.max(0, Math.min(1, track.scrollLeft / range));
    thumb.style.width = thumbW + 'px';
    thumb.style.transform = 'translateX(' + prog * (tw - thumbW) + 'px)';
  }

  function initCardSlider(slider) {
    if (slider.__pzInit) return;
    slider.__pzInit = true;
    var track = slider.querySelector('[data-pz-cardslider-track]');
    if (!track) return;
    var raf = null;
    function onScroll() {
      if (!raf) raf = requestAnimationFrame(function () { raf = null; updateHbar(slider); });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateHbar(slider);

    /* Desktop hover: reveal the 2nd image INSTANTLY (no slide) — like YSL / Totême. The arrows still
       step with a slide animation (they use behavior:'smooth'); only this auto-swap is instant.
       Leaving the card snaps back to the first image. Touch devices keep native swiping. */
    var card = slider.closest('.card-wrapper') || slider;
    function hoverDesktop() { return window.matchMedia('(hover: hover) and (min-width: 750px)').matches; }
    card.addEventListener('mouseenter', function () {
      if (!hoverDesktop() || slides(track).length <= 1) return;
      // 8-col compact view overlays the +/bookmark icons on the image; skip the auto-swap there
      // (a darker 2nd image would hide them). Arrows still work. Other views keep the auto-swap.
      if (slider.closest('.product-grid.grid--8-col-desktop')) return;
      track.scrollTo({ left: track.clientWidth || 0, behavior: 'auto' });
    });
    card.addEventListener('mouseleave', function () {
      if (!hoverDesktop() || slides(track).length <= 1) return;
      track.scrollTo({ left: 0, behavior: 'auto' });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-pz-cardslider]').forEach(initCardSlider);
  }

  /* Desktop arrows (delegated). Steps one slide; loops past either end. */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.pz-cardslider__arrow');
    if (!arrow) return;
    e.preventDefault();
    e.stopPropagation();
    var slider = arrow.closest('[data-pz-cardslider]');
    if (!slider) return;
    var track = slider.querySelector('[data-pz-cardslider-track]');
    var n = slides(track).length;
    if (n <= 1) return;
    var w = track.clientWidth || 1;
    var idx = Math.round(track.scrollLeft / w);
    idx += arrow.classList.contains('pz-cardslider__arrow--next') ? 1 : -1;
    if (idx < 0) idx = n - 1;
    if (idx >= n) idx = 0;
    track.scrollTo({ left: idx * w, behavior: 'smooth' });
  });

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  /* Re-init sliders in grids re-rendered by Dawn's facet filtering / pagination. */
  try {
    /* observe the whole body so re-rendered cart-drawer suggestions get their sliders re-initialised too */
    var gridRoot = document.body;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        (m.addedNodes || []).forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-pz-cardslider]')) initCardSlider(node);
          if (node.querySelectorAll) initAll(node);
        });
      });
    }).observe(gridRoot, { childList: true, subtree: true });
  } catch (err) {}

  /* ================= Colour swatches ================= */
  /* Clicking a sibling colour swaps the card in place (no navigation): rebuilds the image
     slider from that colour's images, and updates title / price / links / active state. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.pz-card-swatch');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    if (sw.classList.contains('pz-card-swatch--active')) return;

    var card = sw.closest('.card-wrapper');
    if (!card) return;
    var url = sw.getAttribute('data-url');
    var alt = sw.getAttribute('data-alt') || '';

    var slider = card.querySelector('[data-pz-cardslider]');
    if (slider) {
      var track = slider.querySelector('[data-pz-cardslider-track]');
      var list = [];
      try { list = JSON.parse(sw.getAttribute('data-images') || '[]'); } catch (err2) {}
      if (track && list.length) {
        track.innerHTML = list.map(function (u) {
          return '<a class="pz-cardslider__slide" href="' + url + '" tabindex="-1">' +
                 '<img src="' + u + '" alt="' + alt.replace(/"/g, '&quot;') + '" class="motion-reduce" loading="lazy"></a>';
        }).join('');
        track.scrollLeft = 0;
        if (list.length > 1) slider.classList.add('pz-cardslider--multi');
        else slider.classList.remove('pz-cardslider--multi');
        updateHbar(slider);
      }
    } else {
      // fallback for the non-slider card structure
      var media = card.querySelector('.card__media .media');
      if (media) {
        var imgs = media.querySelectorAll('img');
        if (imgs[0]) {
          if (sw.getAttribute('data-img')) imgs[0].src = sw.getAttribute('data-img');
          if (sw.getAttribute('data-srcset')) imgs[0].srcset = sw.getAttribute('data-srcset');
          imgs[0].setAttribute('alt', alt);
          imgs[0].style.display = '';
        }
        for (var i = 1; i < imgs.length; i++) imgs[i].style.display = 'none';
      }
    }

    if (url) {
      card.querySelectorAll('a.full-unstyled-link, .card__heading a').forEach(function (a) {
        a.setAttribute('href', url);
      });
    }
    var title = sw.getAttribute('data-title');
    if (title != null) {
      card.querySelectorAll('.card__heading a').forEach(function (a) { a.textContent = title; });
    }
    var price = card.querySelector('.price .price-item--regular');
    var priceStr = sw.getAttribute('data-price');
    if (price && priceStr) price.innerHTML = priceStr;

    var group = sw.closest('.pz-card-swatches');
    if (group) {
      group.querySelectorAll('.pz-card-swatch--active').forEach(function (a) {
        a.classList.remove('pz-card-swatch--active');
        a.removeAttribute('aria-current');
      });
    }
    sw.classList.add('pz-card-swatch--active');
    sw.setAttribute('aria-current', 'true');
  });
})();

/* ================= Quick add to cart (collection cards) =================
   Desktop: material line ⇄ "Añadir a la cesta" / ring sizes on hover.
   Mobile:  persistent "+" over the image; sized rings open a bottom-sheet.
   Success = the cart drawer opens (Dawn's renderContents), like a PDP add.
   Everything is delegated so it survives pagination / AJAX filtering.        */
(function () {
  // this file can be included more than once on a page (e.g. collection grid + global cart
  // drawer). Guard so the delegated click handlers bind only once — otherwise one click adds twice.
  if (window.__pzQuickAddInit) return;
  window.__pzQuickAddInit = true;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function cartEl() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  /* This theme's POST /cart/add returns null for the cart-drawer section (a Liquid/section-render
     quirk), so Dawn's renderContents() throws in getSectionInnerHTML and the drawer never opens —
     the item IS added but there's no feedback. Fall back to re-rendering the drawer with the GET
     Section Rendering API (which works reliably) and then opening it. */
  function openCartFresh(cart) {
    if (!cart) cart = cartEl();
    if (!cart) return;
    function openIt() {
      if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      if (typeof cart.open === 'function') cart.open();
    }
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        try {
          var cd = new DOMParser().parseFromString(data['cart-drawer'] || '', 'text/html').querySelector('#CartDrawer');
          var tgt = document.querySelector('#CartDrawer');
          if (cd && tgt) tgt.innerHTML = cd.innerHTML;
          var bs = new DOMParser().parseFromString(data['cart-icon-bubble'] || '', 'text/html').querySelector('.shopify-section');
          var bt = document.getElementById('cart-icon-bubble');
          if (bs && bt) bt.innerHTML = bs.innerHTML;
          // re-injecting #CartDrawer replaced the overlay node, so Dawn's click-to-close binding
          // is gone — rebind it so clicking outside still closes the drawer.
          var ov = document.querySelector('#CartDrawer-Overlay');
          if (ov && typeof cart.close === 'function') ov.addEventListener('click', function () { cart.close(); });
        } catch (e) {}
        openIt();
      })
      .catch(openIt);
  }

  /* On the cart page itself we don't want the slide-out drawer — the added item should appear
     in the on-page list. Re-render the cart sections via the GET Section Rendering API and swap
     the live regions (item list, order summary, header bubble, suggestions). */
  function onCartPage() { return document.body.classList.contains('template-cart'); }
  function refreshCartPage(done) {
    fetch(window.location.pathname + '?sections=main-cart-items,main-cart-footer,cart-icon-bubble', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        function dp(html) { return new DOMParser().parseFromString(html || '', 'text/html'); }
        var items = dp(data['main-cart-items']);
        var footer = dp(data['main-cart-footer']);
        function swapInner(srcDoc, sel) {
          var src = srcDoc.querySelector(sel), cur = document.querySelector(sel);
          if (src && cur) cur.innerHTML = src.innerHTML;
        }
        function swapNode(srcDoc, sel) {
          var src = srcDoc.querySelector(sel), cur = document.querySelector(sel);
          if (src && cur) cur.replaceWith(src);
        }
        swapInner(items, '#main-cart-items .js-contents');
        swapInner(footer, '#main-cart-footer .js-contents');
        // item-count in the cart-page header
        var nc = items.querySelector('.pz-cartpage__count'), cc = document.querySelector('.pz-cartpage__count');
        if (nc && cc) cc.textContent = nc.textContent;
        // refresh suggestions so the just-added item drops out
        swapNode(items, '.pz-cart-upsell--desktop');
        swapNode(footer, '.pz-cart-upsell--mobile');
        // header cart bubble
        var bubble = dp(data['cart-icon-bubble']).querySelector('.shopify-section'), bt = document.getElementById('cart-icon-bubble');
        if (bubble && bt) bt.innerHTML = bubble.innerHTML;
        // leave the empty state if we were there
        var ci = document.querySelector('cart-items.pz-cartpage');
        if (ci) ci.classList.remove('is-empty');
        if (done) done();
      })
      .catch(function () { if (done) done(); });
  }
  // shared with pz-cart.js (quantity / remove on the cart page use the same GET-based refresh)
  window.pzRefreshCartPage = refreshCartPage;

  function addToCart(variantId, onDone, onErr) {
    var pageCart = onCartPage();
    var cart = pageCart ? null : cartEl();
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = body;
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, config)
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status) { if (onErr) onErr(resp); return; }
        // On the cart page: update the on-page list, no drawer.
        if (pageCart) { refreshCartPage(function () { if (onDone) onDone(resp); }); return; }
        var opened = false;
        if (cart && typeof cart.renderContents === 'function' && resp.sections && resp.sections['cart-drawer']) {
          // fast path: only trust the POST sections when the drawer section actually came back
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          try { cart.renderContents(resp); opened = true; } catch (e) { opened = false; }
        }
        if (!opened) openCartFresh(cart);
        if (onDone) onDone(resp);
      })
      .catch(function (e) { if (onErr) onErr(e); });
  }
  // shared with the wishlist drawer ("Mover a la cesta")
  window.pzAddToCart = addToCart;

  /* ---- Rebuild the card's quick-add target after a colour swatch swap ---- */
  /* Sizes always run smallest → largest (numeric, not lexicographic so 8 < 10). */
  function pzSortVars(list) {
    return list.slice().sort(function (a, b) {
      var na = parseFloat(a.t), nb = parseFloat(b.t);
      if (!isNaN(na) && !isNaN(nb)) return na - nb;
      return String(a.t).localeCompare(String(b.t));
    });
  }
  function buildLineHTML(variants) {
    if (variants.length > 1) {
      return '<div class="pz-qa-sizes" role="group" aria-label="Tallas">' +
        pzSortVars(variants).map(function (v) {
          return '<button type="button" class="pz-qa-size' + (v.a ? '' : ' is-soldout') +
            '" data-pz-add data-variant-id="' + v.id + '"' + (v.a ? '' : ' disabled aria-disabled="true"') +
            '>' + esc(v.t) + '</button>';
        }).join('') + '</div>';
    }
    var v = variants[0] || {};
    var avail = v.a !== false;
    return '<button type="button" class="pz-qa-add" data-pz-add data-variant-id="' + (v.id || '') + '"' +
      (avail ? '' : ' disabled aria-disabled="true"') + '>' + (avail ? ((window.pzI18n&&window.pzI18n.addToCart)||'Añadir a la cesta') : ((window.pzI18n&&window.pzI18n.soldOut)||'Agotado')) + '</button>';
  }
  function rebuildQuickAdd(card, variants, title) {
    var line = card.querySelector('[data-pz-qa]');
    if (line) line.innerHTML = buildLineHTML(variants);
    var plus = card.querySelector('[data-pz-qa-plus]');
    if (plus) {
      plus.setAttribute('data-variants', JSON.stringify(variants));
      if (title != null) plus.setAttribute('data-title', title);
    }
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.pz-card-swatch');
    if (!sw) return;
    var card = sw.closest('.card-wrapper');
    if (!card) return;
    var variants = [];
    try { variants = JSON.parse(sw.getAttribute('data-variants') || '[]'); } catch (err) {}
    if (variants.length) rebuildQuickAdd(card, variants, sw.getAttribute('data-title'));
  });

  /* ---- Desktop line: single "Añadir" or a ring size ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pz-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var line = btn.closest('[data-pz-qa]');
    addToCart(id, function () {
      if (line) {
        line.classList.add('pz-qa--done');
        setTimeout(function () { line.classList.remove('pz-qa--done'); }, 1400);
      }
    });
  });

  /* ---- Mobile "+": direct add, or open the size sheet ---- */
  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-pz-qa-plus]');
    if (!plus) return;
    e.preventDefault();
    e.stopPropagation();
    var variants = [];
    try { variants = JSON.parse(plus.getAttribute('data-variants') || '[]'); } catch (err) {}
    if (variants.length > 1) { openSheet(plus.getAttribute('data-title') || '', variants); return; }
    var v = variants[0];
    if (!v || v.a === false) return;
    plus.classList.add('is-loading');
    addToCart(v.id,
      function () { plus.classList.remove('is-loading'); },
      function () { plus.classList.remove('is-loading'); });
  });

  /* ---- Mobile size bottom-sheet — PDP-style: pick a size (underlines), then Add to cart ---- */
  var sheet = null, sheetVariantId = null;
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'pz-qa-sheet';
    sheet.innerHTML =
      '<div class="pz-qa-sheet__overlay" data-pz-sheet-close></div>' +
      '<div class="pz-qa-sheet__panel" role="dialog" aria-modal="true" aria-label="Elegir talla">' +
      '<button type="button" class="pz-qa-sheet__close" data-pz-sheet-close aria-label="Cerrar">' +
      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" aria-hidden="true"><path d="M3 3 L13 13 M13 3 L3 13"/></svg></button>' +
      '<div class="pz-qa-sheet__sizes" data-pz-sheet-sizes role="radiogroup" aria-label="Talla"></div>' +
      '<button type="button" class="pz-qa-sheet__submit pz-warn" data-pz-sheet-submit>Selecciona una talla</button>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-pz-sheet-close]')) { closeSheet(); return; }
      var sb = e.target.closest('.pz-qa-sheet__size');
      if (sb && !sb.classList.contains('is-soldout')) { selectSize(sb); return; }
      if (e.target.closest('[data-pz-sheet-submit]')) {
        if (sheetVariantId) addToCart(sheetVariantId, function () { closeSheet(); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });
    return sheet;
  }
  function selectSize(sb) {
    var row = sb.parentNode;
    row.querySelectorAll('.pz-qa-sheet__size--active').forEach(function (x) {
      x.classList.remove('pz-qa-sheet__size--active');
      x.setAttribute('aria-checked', 'false');
    });
    sb.classList.add('pz-qa-sheet__size--active');
    sb.setAttribute('aria-checked', 'true');
    sheetVariantId = sb.getAttribute('data-variant-id');
    var sub = sheet.querySelector('[data-pz-sheet-submit]');
    sub.classList.remove('pz-warn');
    sub.textContent = (window.pzI18n&&window.pzI18n.addToCart)||'Añadir a la cesta';
  }
  function openSheet(title, variants) {
    ensureSheet();
    sheetVariantId = null;
    sheet.querySelector('[data-pz-sheet-sizes]').innerHTML = pzSortVars(variants).map(function (v) {
      return '<button type="button" class="pz-qa-sheet__size' + (v.a ? '' : ' is-soldout') +
        '" role="radio" aria-checked="false" data-variant-id="' + v.id + '"' + (v.a ? '' : ' disabled') +
        '>' + esc(v.t) + '</button>';
    }).join('');
    var sub = sheet.querySelector('[data-pz-sheet-submit]');
    sub.classList.add('pz-warn');
    sub.textContent = (window.pzI18n&&window.pzI18n.selectSize)||'Selecciona una talla';
    sheet.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* Server-rendered desktop size tokens come in the merchant's variant order — reorder them
     smallest → largest so they match the sheet (and the swatch-rebuilt line). */
  function sortDesktopSizes(root) {
    (root || document).querySelectorAll('.pz-qa-sizes').forEach(function (row) {
      var btns = [].slice.call(row.querySelectorAll('.pz-qa-size'));
      btns.sort(function (a, b) {
        var na = parseFloat(a.textContent), nb = parseFloat(b.textContent);
        if (!isNaN(na) && !isNaN(nb)) return na - nb;
        return a.textContent.localeCompare(b.textContent);
      }).forEach(function (b) { row.appendChild(b); });
    });
  }
  sortDesktopSizes();
  document.addEventListener('DOMContentLoaded', function () { sortDesktopSizes(); });
})();

/* ================= Collection header controls =================
   Minimal word triggers: "Ver por" (columns), "Ordenar" (sort dropdown), "Filtros" (right drawer). */
(function () {
  // this file loads twice on collection pages (grid + global cart drawer); bind once, otherwise
  // the delegated click toggles the sort menu twice (open→close) and nothing appears to happen.
  if (window.__pzCollHeaderInit) return;
  window.__pzCollHeaderInit = true;

  /* ---- Sort dropdown (word "Ordenar" → menu of options) ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-pz-sort-toggle]');
    if (toggle) {
      // scope to the toggle's OWN dropdown — there are two (title line + tabs row) for related-collection pages
      var sort = toggle.closest('[data-pz-sort]');
      if (sort) {
        e.stopPropagation();
        var open = sort.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
    }
    // DESKTOP header dropdown → navigate (keeps active filters, swaps sort_by)
    var opt = e.target.closest('.pz-tool__opt[data-sort-value]');
    if (opt) {
      e.preventDefault();
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', opt.getAttribute('data-sort-value'));
      var po = opt.getAttribute('data-pz-order');
      if (po) { url.searchParams.set('pz_order', po); } else { url.searchParams.delete('pz_order'); }
      url.searchParams.delete('page');
      window.location.href = url.toString();
      return;
    }
    // MOBILE drawer sort → apply via Dawn's facet AJAX (no reload, drawer stays open, like a filter)
    var dsort = e.target.closest('.pz-drawer-sort__opt');
    if (dsort) {
      e.preventDefault();
      // "Oldest to newest" (pz_order) — and any switch away from it — must reload so the
      // client-side reverse loader runs / clears; the facet AJAX can't carry pz_order.
      var dpo = dsort.getAttribute('data-pz-order');
      if (dpo || new URLSearchParams(window.location.search).get('pz_order')) {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', dsort.getAttribute('data-sort-value'));
        if (dpo) { u.searchParams.set('pz_order', dpo); } else { u.searchParams.delete('pz_order'); }
        u.searchParams.delete('page');
        window.location.href = u.toString();
        return;
      }
      var det = dsort.closest('[data-pz-drawer-sort]');
      var input = det.querySelector('[data-pz-sort-input]');
      det.querySelectorAll('.pz-sort-box').forEach(function (b) { b.classList.remove('is-on'); });
      var box = dsort.querySelector('.pz-sort-box'); if (box) box.classList.add('is-on');
      det.querySelectorAll('.pz-drawer-sort__opt').forEach(function (b) { b.removeAttribute('aria-current'); });
      dsort.setAttribute('aria-current', 'true');
      var selLabel = det.querySelector('.pz-filter-selected');
      if (selLabel) selLabel.textContent = dsort.getAttribute('data-sort-name') || '';
      if (input) { input.value = dsort.getAttribute('data-sort-value'); input.dispatchEvent(new Event('input', { bubbles: true })); }
      return;
    }
    // click outside closes any open menu
    if (!e.target.closest('[data-pz-sort]')) {
      document.querySelectorAll('[data-pz-sort].is-open').forEach(function (s) {
        s.classList.remove('is-open');
        var b = s.querySelector('[data-pz-sort-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ---- Filters drawer (word "Filtros" → right-side panel) ---- */
  function drawer() { return document.querySelector('[data-pz-filterdrawer]'); }
  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var t = document.querySelector('[data-pz-filters-toggle]');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var t = document.querySelector('[data-pz-filters-toggle]');
    if (t) t.setAttribute('aria-expanded', 'false');
    setTimeout(function () { if (d && !d.classList.contains('is-open')) d.hidden = true; }, 340);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pz-filters-toggle]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-pz-filters-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawer();
      if (d && d.classList.contains('is-open')) closeDrawer();
    }
  });
  /* Mirror Dawn's live product count (#ProductCount, kept in sync by facets.js) into the
     footer "Ver N" button, so the button always shows how many products the filters match. */
  function syncApplyCount() {
    var src = document.getElementById('ProductCount');
    var dst = document.querySelector('[data-pz-applycount]');
    if (!src || !dst) return;
    var n = (src.textContent.match(/\d[\d.,]*/) || [])[0];
    if (n) dst.textContent = n;
  }
  (function () {
    var src = document.getElementById('ProductCount');
    if (src) {
      try {
        new MutationObserver(syncApplyCount).observe(src, { childList: true, characterData: true, subtree: true });
      } catch (err) {}
    }
    syncApplyCount();
  })();

  /* ---- "Vista": one button cycles the grid density for the current breakpoint ----
     Desktop cycle: 4 (default) → 6 → 8 (compact) → 3 → back.
     Mobile cycle:  2 (default) → 3 (compact) → 1 → back.
     Desktop + mobile columns are stored separately and both classes live on the grid, so the
     media queries pick the right one; the button cycles whichever breakpoint is active. */
  var DESKTOP_VIEWS = [4, 6, 8, 3];
  var MOBILE_VIEWS = [2, 3, 1];
  function grid() { return document.getElementById('product-grid'); }
  function isDesktop() { return window.matchMedia('(min-width: 750px)').matches; }
  function getStored(key, def) { try { var v = parseInt(localStorage.getItem(key)); return v || def; } catch (e) { return def; } }
  function setStored(key, v) { try { localStorage.setItem(key, String(v)); } catch (e) {} }
  function applyView() {
    var g = grid(); if (!g) return;
    var d = getStored('pz-view-d', 4), m = getStored('pz-view-m', 2);
    var cls = g.className;
    cls = /grid--\d+-col-desktop/.test(cls)
      ? cls.replace(/grid--\d+-col-desktop/g, 'grid--' + d + '-col-desktop')
      : cls + ' grid--' + d + '-col-desktop';
    cls = /grid--\d+-col-tablet-down/.test(cls)
      ? cls.replace(/grid--\d+-col-tablet-down/g, 'grid--' + m + '-col-tablet-down')
      : cls + ' grid--' + m + '-col-tablet-down';
    g.className = cls;
  }
  function cycleView() {
    if (isDesktop()) {
      var d = getStored('pz-view-d', 4), i = DESKTOP_VIEWS.indexOf(d);
      setStored('pz-view-d', DESKTOP_VIEWS[((i < 0 ? 0 : i) + 1) % DESKTOP_VIEWS.length]);
    } else {
      var m = getStored('pz-view-m', 2), j = MOBILE_VIEWS.indexOf(m);
      setStored('pz-view-m', MOBILE_VIEWS[((j < 0 ? 0 : j) + 1) % MOBILE_VIEWS.length]);
    }
    applyView();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pz-vista]')) cycleView();
  });
  applyView();
  /* re-apply after facet AJAX re-renders the grid */
  try {
    var pgc = document.getElementById('ProductGridContainer');
    if (pgc) new MutationObserver(function () { applyView(); }).observe(pgc, { childList: true, subtree: true });
  } catch (err) {}
})();

/* ================= Filters drawer: inline selected values + price line-slider ================= */
(function () {
  function drawer() { return document.querySelector('.pz-filterdrawer'); }

  /* Show each filter's chosen values on the right of its row (replaces Dawn's pills / "(N)"). */
  function updateSelectedLabels() {
    var d = drawer(); if (!d) return;
    d.querySelectorAll('.facets__disclosure-vertical').forEach(function (det) {
      if (det.hasAttribute('data-pz-drawer-sort')) return;   // sort's selection is rendered server-side
      var row = det.querySelector('.facets__summary > div'); if (!row) return;
      var sel = row.querySelector('.pz-filter-selected');
      if (!sel) {
        sel = document.createElement('span'); sel.className = 'pz-filter-selected';
        var caret = row.querySelector('svg'); row.insertBefore(sel, caret || null);
      }
      var labels = [];
      det.querySelectorAll('input[type="checkbox"]:checked').forEach(function (inp) {
        var lab = inp.closest('.facets__label');
        if (!lab) return;
        var tl = lab.querySelector('.facet-checkbox__text-label');
        var t = (tl ? tl.textContent : lab.textContent).replace(/\([^)]*\)/g, '').replace(/\s+/g, ' ').trim();
        if (t) labels.push(t);
      });
      var gte = det.querySelector('input[name="filter.v.price.gte"]');
      var lte = det.querySelector('input[name="filter.v.price.lte"]');
      if (gte || lte) {
        var a = gte && gte.value, b = lte && lte.value;
        if (a || b) labels.push('€' + (a || '0') + ' – €' + (b || '∞'));
      }
      var next = labels.join(', ');
      if (sel.textContent !== next) sel.textContent = next;   // guard: avoids re-triggering the MutationObserver
    });
  }

  /* Thin line slider with two square handles, wired to Dawn's gte/lte price inputs. */
  function num(v) { return parseFloat(String(v == null ? '' : v).replace(/\./g, '').replace(',', '.')) || 0; }
  function initPriceSlider() {
    var d = drawer(); if (!d) return;
    var pr = d.querySelector('price-range'); if (!pr) return;
    if (pr.parentNode.querySelector('.pz-priceslider')) return;   // already built for this render
    var gte = pr.querySelector('input[name="filter.v.price.gte"]');
    var lte = pr.querySelector('input[name="filter.v.price.lte"]');
    if (!gte || !lte) return;
    var max = num(lte.getAttribute('data-max')) || num(gte.getAttribute('data-max'));
    if (max <= 0) return;
    var curMin = num(gte.value), curMax = num(lte.value) || max;

    var wrap = document.createElement('div');
    wrap.className = 'pz-priceslider';
    wrap.innerHTML =
      '<div class="pz-priceslider__track">' +
        '<div class="pz-priceslider__range"></div>' +
        '<button type="button" class="pz-priceslider__handle" data-h="min" aria-label="Precio mínimo"></button>' +
        '<button type="button" class="pz-priceslider__handle" data-h="max" aria-label="Precio máximo"></button>' +
      '</div>' +
      '<div class="pz-priceslider__labels"><span data-l="min"></span><span data-l="max"></span></div>';
    pr.parentNode.insertBefore(wrap, pr);

    var track = wrap.querySelector('.pz-priceslider__track');
    var rangeEl = wrap.querySelector('.pz-priceslider__range');
    var hMin = wrap.querySelector('[data-h="min"]'), hMax = wrap.querySelector('[data-h="max"]');
    var lMin = wrap.querySelector('[data-l="min"]'), lMax = wrap.querySelector('[data-l="max"]');
    function pct(v) { return (v / max) * 100; }
    function render() {
      hMin.style.left = pct(curMin) + '%'; hMax.style.left = pct(curMax) + '%';
      rangeEl.style.left = pct(curMin) + '%'; rangeEl.style.right = (100 - pct(curMax)) + '%';
      lMin.textContent = Math.round(curMin) + ' €'; lMax.textContent = Math.round(curMax) + ' €';
    }
    render();
    function commit() {
      gte.value = curMin > 0 ? String(Math.round(curMin)) : '';
      lte.value = curMax < max ? String(Math.round(curMax)) : '';
      gte.dispatchEvent(new Event('change', { bubbles: true }));
      gte.dispatchEvent(new Event('input', { bubbles: true }));   // triggers the facet form's debounced submit
    }
    function bind(handle, which) {
      handle.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        try { handle.setPointerCapture(e.pointerId); } catch (err) {}
        function move(ev) {
          var r = track.getBoundingClientRect();
          var p = Math.min(1, Math.max(0, (ev.clientX - r.left) / r.width));
          var v = p * max;
          if (which === 'min') curMin = Math.min(v, curMax - 1);
          else curMax = Math.max(v, curMin + 1);
          curMin = Math.max(0, curMin); curMax = Math.min(max, curMax);
          render();
        }
        function up() {
          document.removeEventListener('pointermove', move);
          document.removeEventListener('pointerup', up);
          commit();
        }
        document.addEventListener('pointermove', move);
        document.addEventListener('pointerup', up);
      });
    }
    bind(hMin, 'min'); bind(hMax, 'max');
  }

  /* Move the "Ordenar" section to sit right AFTER Availability (idempotent). */
  function positionSort() {
    var d = drawer(); if (!d) return;
    var sort = d.querySelector('[data-pz-drawer-sort]'); if (!sort) return;
    var form = d.querySelector('.facets__form-vertical'); if (!form) return;
    var avail = form.querySelector('.facets__disclosure-vertical:not([data-pz-drawer-sort])'); if (!avail) return;
    if (avail.nextElementSibling !== sort) avail.parentNode.insertBefore(sort, avail.nextElementSibling);
  }
  function refresh() { positionSort(); initPriceSlider(); updateSelectedLabels(); }
  refresh();
  document.addEventListener('DOMContentLoaded', refresh);
  /* immediate feedback when a checkbox toggles (before the AJAX round-trip) */
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.pz-filterdrawer')) updateSelectedLabels();
  });
  /* Dawn re-renders the .js-filter markup on every AJAX filter change → rebuild our bits. */
  try {
    var host = document.getElementById('main-collection-filters');
    if (host) new MutationObserver(function () { refresh(); }).observe(host, { childList: true, subtree: true });
  } catch (err) {}
})();

/* ================= Infinite scroll (progressive enhancement) =================
   Numbered pagination stays in the DOM (crawlable / no-JS fallback) and is hidden when JS runs.
   Batches auto-load a bit before the shopper reaches the end, with the NEXT batch prefetched
   (double-buffered) so appends are instant. The URL follows the scroll via History.replaceState.
   Save-Data / no-IntersectionObserver → a manual "Cargar más" button instead.               */
(function () {
  /* pz-collection.js is loaded on a collection page by the grid AND by header-search +
     cart-drawer snippets — up to 3 copies on one page. Without this guard each copy sets up
     its own IntersectionObserver, so every "load more" batch was fetched and appended 3× and
     every product appeared tripled. Bind the infinite scroll exactly once. */
  if (window.__pzInfiniteInit) return;
  window.__pzInfiniteInit = true;
  var SUPPORTS_IO = 'IntersectionObserver' in window;
  function saveData() {
    try { var c = navigator.connection; return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))); }
    catch (e) { return false; }
  }
  function foot() { return document.querySelector('.pz-collection-foot'); }
  function grid() { return document.getElementById('product-grid'); }
  function spinner(on) { var s = document.querySelector('[data-pz-infinite-spinner]'); if (s) s.hidden = !on; }
  function preloadMargin() {
    var vh = window.innerHeight || 800;
    return Math.round(vh * (window.matchMedia('(max-width: 749px)').matches ? 1.0 : 1.6));
  }
  function fetchDoc(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
      .catch(function () { return null; });
  }
  function setUrlPage(p) {
    try {
      var url = new URL(window.location.href);
      if (p <= 1) url.searchParams.delete('page'); else url.searchParams.set('page', p);
      if (url.toString() !== window.location.href) history.replaceState({ pzPage: p }, '', url.toString());
    } catch (e) {}
  }

  var state = null;

  function teardown() {
    if (!state) return;
    if (state.io) state.io.disconnect();
    if (state.urlIo) state.urlIo.disconnect();
    state = null;
  }
  function prefetch() {
    if (!state || !state.nextUrl || state.buffered) return;
    state.buffered = fetchDoc(state.nextUrl);
  }
  function appendFrom(doc) {
    if (!state) return null;
    var newGrid = doc.getElementById('product-grid');
    if (!newGrid || grid() !== state.gridNode) return null;
    var items = newGrid.querySelectorAll('li.grid__item');
    if (!items.length) return null;
    var frag = document.createDocumentFragment(), first = null;
    items.forEach(function (li, i) { var c = document.importNode(li, true); if (i === 0) first = c; frag.appendChild(c); });
    state.gridNode.appendChild(frag);
    var nf = doc.querySelector('.pz-collection-foot');
    return {
      next: nf ? nf.getAttribute('data-pz-next-url') : null,
      loadedPage: nf ? (parseInt(nf.getAttribute('data-pz-page')) || null) : null,
      firstItem: first
    };
  }
  function loadNext() {
    if (!state || state.loading || !state.nextUrl) return;
    state.loading = true; spinner(true);
    var p = state.buffered || fetchDoc(state.nextUrl);
    state.buffered = null;
    p.then(function (doc) {
      if (!state) return;
      state.loading = false; spinner(false);
      if (!doc) return;
      var res = appendFrom(doc);
      if (!res) return;
      if (res.firstItem && res.loadedPage) {
        res.firstItem.setAttribute('data-pz-page', res.loadedPage);
        if (state.urlIo) state.urlIo.observe(res.firstItem);
      }
      state.nextUrl = res.next;
      var lm = document.querySelector('[data-pz-loadmore]');
      if (lm) { if (state.nextUrl) lm.setAttribute('href', state.nextUrl); }
      if (!state.nextUrl) {
        if (state.io) state.io.disconnect();
        var f = foot(); if (f) f.classList.add('is-done');
      } else {
        prefetch();
        // In dense views (e.g. 8-col) one page is only a few short rows and doesn't push the
        // foot out of the preload band, so the foot stays continuously intersecting and the
        // IntersectionObserver never re-fires. Re-observe to force a fresh intersection check:
        // if the foot is still within the band it fires again (loading the next batch); once
        // enough content has been appended to push it out, the callback sees isIntersecting=false
        // and stops. This keeps the auto-load chaining in short/dense layouts.
        var fe = foot();
        if (state.io && fe) { state.io.unobserve(fe); state.io.observe(fe); }
      }
    });
  }
  function onMarker(entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { var pp = e.target.getAttribute('data-pz-page'); if (pp) setUrlPage(parseInt(pp)); }
    });
  }

  function init() {
    // In a date-sort mode (pz_order=new/old) a separate loader owns the grid (loads all pages +
    // sorts by newness); the forward infinite scroll must not also run.
    var _pzo = new URLSearchParams(window.location.search).get('pz_order');
    if (_pzo === 'new' || _pzo === 'old' || _pzo === 'oldest') { teardown(); return; }
    var f = foot(), g = grid();
    if (!f || !g || !f.hasAttribute('data-pz-infinite')) { teardown(); return; }
    if (state && state.gridNode === g) return;   // already set up for this grid
    teardown();
    state = {
      gridNode: g,
      nextUrl: f.getAttribute('data-pz-next-url') || null,
      currentPage: parseInt(f.getAttribute('data-pz-page')) || 1,
      loading: false, buffered: null, io: null, urlIo: null
    };
    var firstLi = g.querySelector('li.grid__item');
    if (firstLi) firstLi.setAttribute('data-pz-page', state.currentPage);
    var auto = SUPPORTS_IO && !saveData();
    f.classList.add('is-js', auto ? 'is-auto' : 'is-manual');
    if (!state.nextUrl) { f.classList.add('is-done'); return; }
    if (auto) {
      state.urlIo = new IntersectionObserver(onMarker, { rootMargin: '-12% 0px -85% 0px' });
      if (firstLi) state.urlIo.observe(firstLi);
      state.io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) loadNext();
      }, { rootMargin: '0px 0px ' + preloadMargin() + 'px 0px' });
      state.io.observe(f);
      prefetch();   // warm the buffer right away
    }
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(init, 60); }

  /* manual "Cargar más" (Save-Data / no-IO), and JS fallback for any load-more click */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pz-loadmore]');
    if (!b) return;
    var f = b.closest('.pz-collection-foot');
    if (f && f.classList.contains('is-js')) { e.preventDefault(); loadNext(); }
  });

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  /* Re-init when Dawn's facet AJAX replaces the grid (new #product-grid node). */
  try {
    var pgc = document.getElementById('ProductGridContainer');
    if (pgc) new MutationObserver(function () {
      if (!state || grid() !== state.gridNode) schedule();
    }).observe(pgc, { childList: true, subtree: true });
  } catch (err) {}
})();

/* Collection footer description: show "Ver más" only when the 2-line clamp actually truncates. */
(function () {
  // this file loads twice on collection pages; bind once, else the click toggles expand→collapse.
  if (window.__pzCollDescInit) return;
  window.__pzCollDescInit = true;
  var desc = document.querySelector('[data-pz-desc]');
  var btn = document.querySelector('[data-pz-desc-more]');
  if (!desc || !btn) return;
  function check() {
    if (desc.classList.contains('is-expanded')) return;
    btn.hidden = (desc.scrollHeight - desc.clientHeight <= 2);
  }
  check();
  window.addEventListener('resize', check);
  btn.addEventListener('click', function () {
    var open = desc.classList.toggle('is-expanded');
    btn.textContent = open ? ((window.pzI18n&&window.pzI18n.seeLess)||'Ver menos') : ((window.pzI18n&&window.pzI18n.seeMore)||'Ver más');
  });
})();

/* ============================================================
   "Oldest to newest" sort (?sort_by=manual&pz_order=oldest).
   Automated collections expose only ONE custom order (manual = newest→oldest) and no
   metafield/date sort, so there is no native reverse. We load every page of the manual
   order and reverse it client-side. The forward infinite scroll is disabled in this mode
   (see init() bail above). Runs once per page load.
   ============================================================ */
(function () {
  if (window.__pzOldestInit) return;
  window.__pzOldestInit = true;
  var params = new URLSearchParams(window.location.search);
  var PZO = params.get('pz_order');
  if (PZO !== 'new' && PZO !== 'old' && PZO !== 'oldest') return;
  var ASC = (PZO === 'old' || PZO === 'oldest');   // oldest→newest ascending; else newest first

  function grid() { return document.getElementById('product-grid'); }
  function fetchDoc(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (h) { return new DOMParser().parseFromString(h, 'text/html'); })
      .catch(function () { return null; });
  }

  function run() {
    var g = grid();
    if (!g) return;
    var foot = document.querySelector('.pz-collection-foot');
    var spinner = document.querySelector('[data-pz-infinite-spinner]');
    g.style.transition = 'opacity 0.2s ease';
    g.style.opacity = '0.35';
    if (spinner) spinner.hidden = false;

    var items = [].slice.call(g.querySelectorAll('li.grid__item'));
    var next = foot ? foot.getAttribute('data-pz-next-url') : null;

    function step() {
      if (!next) { finish(); return; }
      fetchDoc(next).then(function (doc) {
        if (!doc) { finish(); return; }
        var ng = doc.getElementById('product-grid');
        if (ng) items = items.concat([].slice.call(ng.querySelectorAll('li.grid__item')));
        var nf = doc.querySelector('.pz-collection-foot');
        next = nf ? nf.getAttribute('data-pz-next-url') : null;
        step();
      });
    }

    function finish() {
      // Sort by the per-product newness value (data-pz-newness) rather than reversing the
      // server order — the server order is now "Más relevantes" (relevance + newness), so the
      // date sorts must re-sort purely by newness, independent of the relevance boosts.
      function nv(li) { return parseInt(li.getAttribute('data-pz-newness'), 10) || 0; }
      items.sort(function (a, b) { return ASC ? (nv(a) - nv(b)) : (nv(b) - nv(a)); });
      var frag = document.createDocumentFragment();
      items.forEach(function (li) { frag.appendChild(document.importNode(li, true)); });
      g.innerHTML = '';
      g.appendChild(frag);           // body MutationObserver re-inits card sliders on these nodes
      if (foot) foot.remove();       // everything is loaded — no pagination in a fully-sorted view
      if (spinner) spinner.hidden = true;
      g.style.opacity = '1';
      // Correct the active state / current-sort label (server couldn't see pz_order).
      var marker = ASC ? '[data-pz-sort-oldest]' : '[data-pz-sort-newest]';
      var other = ASC ? '[data-pz-sort-newest]' : '[data-pz-sort-oldest]';
      var actOpt = document.querySelector(marker);
      var lbl = actOpt ? (actOpt.getAttribute('data-sort-name') || actOpt.textContent.trim()) : '';
      document.querySelectorAll(marker).forEach(function (a) { a.classList.add('is-active'); a.setAttribute('aria-current', 'true'); var bx = a.querySelector('.pz-sort-box'); if (bx) bx.classList.add('is-on'); });
      document.querySelectorAll(other + ',[data-pz-sort-rel]').forEach(function (a) { a.classList.remove('is-active'); a.removeAttribute('aria-current'); var bx = a.querySelector('.pz-sort-box'); if (bx) bx.classList.remove('is-on'); });
      var sel = document.querySelector('.pz-drawer-sort .pz-filter-selected');
      if (sel && lbl) sel.textContent = lbl;
    }

    step();
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
